module.exports = __webpack_public_path__ + "themes/fq/sound/audio-sprite.mp3";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sound/audio-sprite.mp3
// module id = 24
// module chunks = d-game